<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Maintenance Users</h1>
      <v-data-table
        :items="items"
        :headers="headers"
        :options.sync="pagination"
        :server-items-length="totalData"
        :loading="loading"
        :footer-props="footerProps"
      >
        <template v-slot:item.status="{ item }">
          <v-btn icon @click.prevent="logoff(item)" :disabled="!item.status">
            <v-icon :color="item.status ? 'success' : '#ECEFF1'"
              >mdi-circle</v-icon
            >
          </v-btn>
        </template>
        <template v-slot:item.login="{ item }">
          <span>{{ item.login | dateTimeFormat }}</span>
        </template>

        <template v-slot:item.logout="{ item }">
          <span>{{ item.logout | dateTimeFormat }}</span>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="logoffDialog" width="200">
      <v-card>
        <v-card-title>
          <span class="headline">Confirmation</span>
        </v-card-title>
        <v-card-text>
          <p>Do you want to logout this user?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click.stop="confirm">Yes</v-btn>
          <v-btn color="error" text @click.stop="logoffDialog = false"
            >close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/userLog";
import _ from "lodash";
export default {
  mixins: [userAccessMixin],
  data: () => ({
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    items: [],
    headers: [
      { text: "User", value: "fullName", sortable: false },
      { text: "Login Date", value: "login", sortable: false },
      { text: "Logout Date", value: "logout", sortable: false },
      { text: "URL", value: "ipAddress", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    logoffDialog: false,
    selectedUser: {},
    totalData: 0,
    footerProps: {
      rowsPerPageItems: [10, 25, 50, 100],
    },
    loading: false,
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(
          `${API_ENDPOINT}/pageNum/${this.pagination.page}/pageSize/${this.pagination.rowsPerPage}`
        )
        .then(({ data }) => {
          this.items = data;
          this.totalData = _.isEmpty(data) ? 0 : data[0].totalRecords;
          // this.pagination.totalItems = data[0].TotalRecords
          this.loading = false;
        })
        .catch(({ response }) => {
          this.loading = false;
          this.toast.show(response.data);
        });
    },
    logoff(item) {
      this.selectedUser = Object.assign({}, item);
      this.logoffDialog = true;
    },
    confirm() {
      this.logoffDialog = false;
      this.$axios
        .put(`${API_ENDPOINT}/off`, this.selectedUser)
        .then(({ data }) => {
          this.getAll();
        })
        .catch(({ response }) => {
          this.toast.show(response.data);
        });
    },
  },
  watch: {
    pagination(val, oldVal) {
      if (JSON.stringify(val) != JSON.stringify(oldVal)) this.getAll();
    },
  },
  created() {
    this.getUserAccessRights("MaintUsrAd");
    this.getAll();
  },
};
</script>
